export default __webpack_public_path__ + "static/media/logo.67a7aa13.png";